import { render, staticRenderFns } from "./newGift.vue?vue&type=template&id=db4b7f7e&scoped=true"
import script from "./newGift.vue?vue&type=script&lang=js"
export * from "./newGift.vue?vue&type=script&lang=js"
import style0 from "./newGift.vue?vue&type=style&index=0&id=db4b7f7e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4b7f7e",
  null
  
)

export default component.exports